import { action, computed, observable, makeObservable } from 'mobx';
import {StringControl} from '../../../../../lib/helpers';
import {GroupingExerciseModel, GroupModel} from '../models';

function isEmpty(str: string) {
  return str === null || str === undefined || str.trim() === '';
}

function nonEmptyLines(value: string): string[] {
  if (value === null || value === undefined)
    return [];
  const lines = value.split('\n');
  return lines.filter(x => !isEmpty(x));
}

class Group {
  readonly label = new StringControl('', '');
  readonly lines = new StringControl('', '');

  constructor() {
    makeObservable(this);
  }

  @computed
  get isLabelEmpty() {
    return isEmpty(this.label.value);
  }

  @computed
  get isGroupEmpty() {
    return nonEmptyLines(this.lines.value).length === 0;
  }

  @computed
  get valid() {
    return !this.isLabelEmpty || !this.isGroupEmpty;
  }

  get model(): GroupModel {
    return {
      label: this.label.value.trim(),
      items: nonEmptyLines(this.lines.value).map(x => x.trim())
    };
  }
}

export class GrexEditStore {
  @observable.shallow
  readonly groups: Group[] = [];

  constructor() {
    makeObservable(this);
    for (let i = 0; i < 3; i++)
      this.addGroup();
  }

  @action
  addGroup = () => {
    this.groups.push(new Group());
  };

  @action
  removeGroup = (index: number) => {
    this.groups.splice(index, 1);
  };

  @action
  sync(model: GroupingExerciseModel) {
    this.groups.length = 0;
    for (let group of model.groups) {
      const store = new Group();
      this.groups.push(store);
      store.label.setValue(group.label);
      store.lines.setValue(group.items.join('\n'));
    }
  }

  @computed
  get valid(): boolean {
    if (this.groups.length < 2)
      return false;
    for (let group of this.groups)
      if (!group.valid)
        return false;
    return true;
  }

  @computed
  get x9Contents(): string {
    if (!this.valid)
      return '';
    const groups: GroupModel[] = [];
    for (let group of this.groups)
      groups.push(group.model);
    const model: GroupingExerciseModel = {groups: groups};
    return JSON.stringify(model);
  }
}
